import { PayItems } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const PayItemsSummary = new CIMSPageItem({
  id: '34ac4ac0-891c-4141-ac6b-fd685b986e24',
  name: 'Summary',
  pathname: 'summary',
  module: PayItems,
})
export const ManagePayItems = new CIMSPageItem({
  id: 'a51ce306-4ca2-4a95-bcee-253975233805',
  name: 'Manage',
  pathname: 'manage',
  module: PayItems,
})
export type PayItemsPageItem = typeof PayItemsSummary | typeof ManagePayItems
